import { useMediaQuery } from '@vueuse/core'
import { type ComputedRef } from 'vue'
import { MOBILE_BREAKPOINT } from '@/constants'

// Checks whether user display is desktop size
export const isDesktop: ComputedRef<boolean> = useMediaQuery(`(min-width: ${MOBILE_BREAKPOINT})`)
